import { render, staticRenderFns } from "./pantalla7movil.vue?vue&type=template&id=179f8070&scoped=true&"
import script from "./pantalla7movil.vue?vue&type=script&lang=js&"
export * from "./pantalla7movil.vue?vue&type=script&lang=js&"
import style0 from "./pantalla7movil.vue?vue&type=style&index=0&id=179f8070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f8070",
  null
  
)

export default component.exports